import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useStockCheckDetailModel } from "./stockCheckDetailsModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "../../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { debounce } from "lodash";
interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    purchasePoDetails: React.MutableRefObject<IYhFormRef | undefined>
}
// interface ITopType extends RouterParamType,React.MutableRefObject<IYhFormRef>{}
export const TopButs: FC<ITopType> = ({ id, mode, purchasePoDetails }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailAddForm, detailLookForm, detailEditForm, insertDetail, editDetail, getDetailEditOne, onComplete, onExamine, onFinalAudit } = useStockCheckDetailModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    const save = async () => {
        purchasePoDetails.current?.validateFields().then(res => {
            if (mode == "add") {
                const resData = insertDetail(res)
                if (resData) {
                    // goBack() && globalPrompt("message", { text: "新增成功", type: "success" })
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                }
            } else if (mode == "edit") {
                let { id } = detailEditForm
                const resData = editDetail({ ...res, id })
                if (resData) {
                    // goBack() && globalPrompt("message", { text: "编辑成功", type: "success" })
                    goBack() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })

                }
            }
        })
    }
    const goBack = async () => {
        replaceNav(selectedNavId, "4-2")
    }
    const Complete = async () => {
        let { stocktakingCode, id, status } = detailEditForm as { id: string, stocktakingCode: string, status: string }
        if (status !== "stocktaking.create") { return message.error(Locale["The document has been completed and cannot be operated again."]) }
        let retData = await onComplete({ stocktakingCode, id })
        retData ? message.success(Locale["Stocktaking succeeded."]) && getDetailEditOne(stocktakingCode, mode) : message.error(Locale["Stocktaking failed."])
    }
    const Examine = async () => {
        let { stocktakingCode, id, status } = detailEditForm as { id: string, stocktakingCode: string, status: string }
        if (status !== "stocktaking.audit") { return message.error(Locale["Document is not in pending approval status"]) }
        let retData = await onExamine({ stocktakingCode, id })
        retData ? message.success(Locale["Financial audit completed"]) && getDetailEditOne(stocktakingCode, mode) : message.error(Locale["Financial audit failed"])
    }
    const FinalAudit = async () => {
        let { stocktakingCode, id, status } = detailEditForm as { id: string, stocktakingCode: string, status: string }
        if (status !== "stocktaking.financial audit") { return message.error(Locale["The document is not in financial approved status"]) }
        let retData = await onFinalAudit({ stocktakingCode, id })
        retData ? message.success(Locale["Manager review succeeded"]) && getDetailEditOne(stocktakingCode, mode) : message.error(Locale["Manager approval failed"])
    }
    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={debounce(() => { save() }, 900)}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => Complete()}
        >{Locale["Finish"]}</Button>}
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => Examine()}
        >{Locale["Financial audit"]}</Button>}
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => FinalAudit()}
        >{Locale["Reviewed by Chief Supervisor"]}</Button>}
    </>;

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }

    const orderStatu: IDescription[] = [
        {
            label: Locale["Stocktaking Doc No."],//"盘点单号",
            value: typeTitle[mode]?.stocktakingCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: getTreeNodeName(typeTitle[mode]?.status as string) as string || Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}